import { Alert, Box, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

import { useRentalManagerUserPropertySummaryWebApiHandler_listing } from '@zg-rentals/ts-rental-manager-api-client-react-query';

type Props = {
  listingAlias: string;
  onClose: () => void;
  onCloneClick: () => void;
  setAddPropertyModalConfig: (config: { isOpen: boolean; behavior: 'Add' | 'Edit' }) => void;
};

const bodyText =
  'Once a property is created, its address can’t be edited. If the address was entered wrong, you’ll need to create a new property with the correct address instead.';

const staticAlertRole = 'presentation' as 'status';

const AboutAddressEditsModal = ({ listingAlias, onClose, onCloneClick, setAddPropertyModalConfig }: Props) => {
  const { data: { isCloneListingRestricted = false } = {} } = useRentalManagerUserPropertySummaryWebApiHandler_listing(
    { listingAlias },
    { enabled: Boolean(listingAlias) },
  );

  const showCreatePropertyModal = () => {
    setAddPropertyModalConfig({ isOpen: true, behavior: 'Add' });
    setTimeout(() => onClose(), 300);
  };

  const handleCloneThisListingClick = () => {
    setTimeout(() => onClose(), 300);
    onCloneClick();
  };

  return (
    <Modal
      header={
        <Heading level={2} textStyle="heading-xs">
          Change property address
        </Heading>
      }
      body={
        <Alert.Root tone="warning" role={staticAlertRole} data-test="modal-body">
          <Alert.Body>
            <Paragraph css={{ marginBlockEnd: '300' }}>{bodyText}</Paragraph>

            <Alert.Action>
              <Box
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '300',
                  alignItems: 'flex-start',
                }}
              >
                <TextButton onClick={showCreatePropertyModal}>Create a new property</TextButton>

                {!isCloneListingRestricted && (
                  <TextButton onClick={handleCloneThisListingClick}>Clone this property</TextButton>
                )}
              </Box>
            </Alert.Action>
          </Alert.Body>
        </Alert.Root>
      }
      onOpenChange={(open) => !open && onClose()}
      open={true}
      size={{ base: 'fullScreen', md: 'md' }}
    />
  );
};

export default AboutAddressEditsModal;
